<template>
  <div class="workflowApplyBox">
    <!-- 模板 -->
    <div class="content">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="index" label="序号" width="50" :index="(index) => { return (curPage - 1) * limit + index + 1 }" />
        <el-table-column prop="name" label="名称" />
        <el-table-column prop="version" label="版本">
          <template slot-scope="{ row }">
            {{ row.version }}_版本
          </template>
        </el-table-column>
        <el-table-column prop="definitionId" label="流程定义ID" />
        <el-table-column label="操作" width="150">
          <template slot-scope="{ row }">
            <el-link :underline="false" type="primary" v-if="row.busCode === 'user_defined '" @click="startBtn(row.definitionId)">启动流程</el-link>
            <el-link :underline="false" type="danger" style="margin-left: 9px" @click="delBtn(row.deploymentId)">删除流程</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 10px">
        <Page :total="total"
          :page-size="limit"
          :current="curPage"
          @on-change="pageChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { getModalList, InitiateApplication, getRescord } from "@/api/workStation"
import { lawsRegulationsList, getAlluser } from "@/api/processManager"
import { technologicalPro, delModel, startModel } from "@/api/model"
export default {
  name: 'workflowApply',
  data() {
    return {
      tableData: [],
      modalList: [],
      limit: 10,
      total: 0,
      curPage: 1,

    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    // 获取流程定义
    getData() {
      technologicalPro({ limit: this.limit, curPage: this.curPage }).then(res => {
        this.tableData = res.body.data
        this.total = res.body.cum
      })
    },
    pageChange(page) {
      this.curPage = page
      this.getData()
    },
    // 启动流程
    startBtn(processDefinitionId) {
      startModel({ processDefinitionId: processDefinitionId }).then(res => {
        this.$message.success('发起成功！')
        this.getData()
      })
    },
    // 删除流程
    delBtn(deploymentId) {
      this.$confirm('删除该流程, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(1111)
        delModel({ deploymentId: deploymentId }).then(res => {
          this.$message.success('删除成功')
          this.getData()
        })
      }).catch(() => {
        return     
      });
    }
  }
}
</script>

<style scoped>
.chooseBox {
  width: 100%;
  height: 130px;
  /* border: 1px solid black; */
  white-space: nowrap;
  overflow: auto;
  padding: 0 25px 0 0;
  box-sizing: border-box;
  border: 1px solid #f2f2f2
}
.goalAndRecrd p {
  font-size: 16px;
  padding: 2px;
}
.clips {
  width: 400px;
  height: 80px;
  /* background-color: #F2F6FC; */
  margin: 5px 10px 0 10px;
  display: inline-block;
  /* position: relative;
  top: 10px; */
  border-radius: 6px
}
.clips /deep/ .el-card {
  width: 100%;
  height: 100%;
}
.chooseBox::-webkit-scrollbar{
  display: none !important
}
.active {
  background: #409EFF;
  color: white
}
.goalAndRecrd {
  width: 100%;
  /* border: 1px solid #f2f2f2; */
  margin-top: 20px;
  display: flex;
  justify-content: space-between
}
.goal {
  width: 48%;
  border: 1px solid #f2f2f2;
  position: relative;
  height: calc(100vh - 280px);
}
.submitBtn {
  position: absolute;
  right: 10px;
  bottom: 10px;
}
.record {
  width: 48%;
  border: 1px solid #f2f2f2;
  height: calc(100vh - 280px);
  position: relative;
}
.recordTableBox {
  padding: 5px;
}
.pageBox {
  text-align: right;
  position: absolute;
  bottom: 10px;
  right: 10px;
}
/* 抽屉样式 */
.drawerTitle {
  box-shadow: 0px 5px 5px -5px black;
  height: 60px;
  padding-left: 15px;
}
.drawerTitle > p {
  color: #000000;
  font-size: 18px;
  line-height: 55px;
}
.drawerTitle > p > i {
  font-size: 30px;
  float: right;
  margin: 15px 10px 0 0;
}
.drawerTitle > p > i:hover {
  color: #409EFF
}
.workflowApplyBox /deep/ .el-drawer__header {
  padding: 0;
  margin-bottom: 0
}
.tWord {
  display: flex
}
.tWord div > p {
  font-size: 15px;
  line-height: 25px
}
.tWord div > span {
  color: #000000
}
.tWord div {
  width: 220px
}
.drawerBody {
  width: 100%;
  height: calc(100vh - 50px);
  background: rgb(247,247,247);
  overflow: hidden;
  padding: 10px 20px 20px;
}
.bodyInner {
  background: white;
  height: calc(100% - 60px);
  width: 100%;
  border: 1px solid #eaeaea;
  overflow: scroll;
  padding: 25px
}
/* 解决tab切换会有蓝色边框的问题 */ 
.workflowApplyBox /deep/ .el-tabs__item:focus.is-active.is-focus:not(:active) {
  box-shadow: none;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
</style>